import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const EditPencilIcon = ({ color, ...rest }) => (
    
 <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 16 18" {...rest}>
 {/* <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 16 18"> */}
    <defs>
        <path id="a" d="M0 .255h14.794v17.464H0z"/>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g transform="translate(.676 .026)">
            <mask id="b" fill={color}>
                <use href="#a"/>
                {/* <use xlink:href="#a"/> */}
            </mask>
            <path fill={color} d="M1.592 12.862l-.716 3.924 3.304-1.154a602.565 602.565 0 0 1 9.336-11.298c.254-.323.407-.718.433-1.132a1.7 1.7 0 0 0-.421-1.037l-.748-.747c-.265-.244-.613-.363-.918-.305l-.053.006a1.109 1.109 0 0 0-.883.488l-.025.034-1.096 1.335C7.11 6.263 4.322 9.661 1.592 12.862M.667 17.72a.658.658 0 0 1-.211-.035.709.709 0 0 1-.426-.405L0 17.204l.007-.353.753-4.13c.008-.187.07-.284.195-.412C3.678 9.115 6.46 5.722 9.153 2.44l1.083-1.32a1.96 1.96 0 0 1 1.498-.843c.558-.095 1.166.103 1.63.532l.772.77c.392.425.621.988.657 1.596l.001.024v.023a2.899 2.899 0 0 1-.625 1.645 604.322 604.322 0 0 0-9.35 11.315.573.573 0 0 1-.396.258L.957 17.65a.653.653 0 0 1-.29.068" mask="url(#b)"/>
        </g>
        <path fill={color} d="M5.585 15.398l-3.319-3.234.59-.604 3.318 3.234zM12.753 6.732L9.52 3.498l.596-.597 3.235 3.235z"/>
    </g>
</svg>


)
/* --------------------------------------------- */
EditPencilIcon.propTypes = {
    /** Color of icon. */
    color: PropTypes.string,
    /** Icon css styles. */
    style: PropTypes.object
}
/* --------------------------------------------- */
EditPencilIcon.defaultProps = {
    color: 'transparent',
}
/* --------------------------------------------- */
export default EditPencilIcon
/* --------------------------------------------- */
